/*
 * *****************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Wed, Jul 21st 2021, 8:19:07 pm
 *
 * *****************************************************
 */

/**
 * Format verififcation code using the following format: 6 characters divided into 2 groups of 3 which are separated by a space character; selected character must be number and letter; all letter must be converted to uppercased format. The function must be used in conjuction with  deformatCode function
 * @param {string} value Verififcation code value
 * @returns {string | undefined} Formatted verififcation code
 */
export const formatCode = (value: string): string => {
  if (!value) return value;
  const onlyLettersAndNums = value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
  if (onlyLettersAndNums.length <= 3) return onlyLettersAndNums;
  return `${onlyLettersAndNums.slice(0, 3)} ${onlyLettersAndNums.slice(3, 6)}`;
};
/**
 * Format verififcation code using the following format: 6 characters; no space character. The function must be used in conjuction with  formatCode function
 * @param {string} value Verififcation code value
 * @returns {string | undefined} Formatted verififcation code
 */
export const deformatCode = (value: string): string => {
  if (!value) return value;
  return value.replace(/ /g, '').slice(0, 6);
};
